import { Link } from "react-router-dom";
import { ArrowLeft, Cookie, Mail } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import DeleteAccountSection from "@/components/account/DeleteAccountSection";
import { openCookieSettings } from "@/components/CookieConsent";

export default function CustomerSettings() {
  const { user } = useAuth();

  return (
    <main className="min-h-screen bg-brand-wash">
      <div className="mx-auto max-w-3xl px-4 py-8">
        <Link to="/dashboard" className="inline-flex items-center gap-1 text-sm text-brand-green">
          <ArrowLeft size={15}/> Tilbage
        </Link>

        <div className="mt-4">
          <div className="font-mono text-[11px] uppercase tracking-widest text-brand-muted">Konto</div>
          <h1 className="font-display text-3xl font-bold text-brand-ink">Indstillinger</h1>
          <p className="mt-2 text-sm text-brand-muted">Administrer din konto og dine cookievalg.</p>
        </div>

        <section className="mt-6 space-y-4">
          <div className="card-outline bg-white p-5 sm:p-6">
            <div className="flex items-start gap-3">
              <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand-fresh">
                <Mail size={18}/>
              </div>
              <div>
                <h2 className="font-semibold text-brand-ink">E-mail</h2>
                <p className="mt-1 text-sm text-brand-body">{user?.email}</p>
                <p className="mt-1 text-xs leading-5 text-brand-muted">Denne e-mail bruges til login og beskeder om dine forespørgsler.</p>
              </div>
            </div>
          </div>

          <div className="card-outline bg-white p-5 sm:p-6">
            <div className="flex items-start gap-3">
              <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-soft text-brand-fresh">
                <Cookie size={18}/>
              </div>
              <div className="min-w-0 flex-1">
                <h2 className="font-semibold text-brand-ink">Cookies</h2>
                <p className="mt-1 text-sm leading-6 text-brand-muted">Vælg om SpørgMig kun må bruge nødvendige cookies eller også cookies til statistik.</p>
                <button type="button" onClick={openCookieSettings} className="btn-secondary mt-4">Administrer cookies</button>
              </div>
            </div>
          </div>

          <DeleteAccountSection/>
        </section>
      </div>
    </main>
  );
}

